export const de = {
  primary: {
    main: "#fd6983",
    dark: "#6a27e8"
  },
  secondary: {
    main: "#378aff"
  },
  error: {
    main: "#e40000"
  },
  custom: {
    main: "#b0c0da"
  },
  questionnaire: {
    section: "#fd6983",
    textPrimary: "#2b2a28",
    textSecondary: "#b0c0da",
    textRequired: "#e40000",
    stripe: "#f1f3f8",
    selection: "#b0c0da",
    checked: "#378aff"
  },
  auth: {
    error: "#e40000",
    main: "#b0c0da",
    title: {
      font: "'Paytone One', sans- serif"
    },
    cta: "#6a27e8",
    readonly: "#b0c0da",
    tnc: "#2b2a28"
  }
};

export const arvr = {
  primary: {
    main: "#8700a1",
    dark: "#CC278D"
  },
  secondary: {
    main: "#378aff"
  },
  error: {
    main: "#e40000"
  },
  custom: {
    main: "#b0c0da"
  },
  questionnaire: {
    section: "#8700a1",
    textPrimary: "#2b2a28",
    textSecondary: "#b0c0da",
    textRequired: "#e40000",
    stripe: "rgba(181, 183, 188, 0.14)",
    selection: "#b0c0da",
    checked: "#378aff"
  },
  auth: {
    error: "#e40000",
    main: "#b0c0da",
    title: {
      font: "'Paytone One', sans- serif"
    },
    cta: "#8700a1",
    readonly: "#b0c0da",
    tnc: "#2b2a28"
  }
};

export const meta = {
  primary: {
    main: "#0668E1",
    dark: "#00044c"
  },
  secondary: {
    main: "#4a5568"
  },
  error: {
    main: "#e40000"
  },
  custom: {
    main: "#b0c0da"
  },
  questionnaire: {
    section: "#b0c0da",
    textPrimary: "#000000",
    textSecondary: "#4a5568",
    textRequired: "#e40000",
    stripe: "rgba(243, 251, 255, 1.0)",
    selection: "#0668E1",
    checked: "#0668E1"
  },
  auth: {
    error: "#e40000",
    main: "#b0c0da",
    title: {
      font: "'Paytone One', sans- serif"
    },
    cta: "#8700a1",
    readonly: "#b0c0da",
    tnc: "#2b2a28"
  }
};

export const mulesoft = {
  primary: {
    main: "#00a2df",
    dark: "#00044c"
  },
  secondary: {
    main: "#4a5568"
  },
  error: {
    main: "#e40000"
  },
  custom: {
    main: "#b0c0da"
  },
  questionnaire: {
    section: "#b0c0da",
    textPrimary: "#000000",
    textSecondary: "#4a5568",
    textRequired: "#e40000",
    stripe: "rgba(243, 251, 255, 1.0)",
    selection: "#00a2df",
    checked: "#00a2df"
  },
  auth: {
    error: "#e40000",
    main: "#b0c0da",
    title: {
      font: "'Paytone One', sans- serif"
    },
    cta: "#8700a1",
    readonly: "#b0c0da",
    tnc: "#2b2a28"
  }
};

export const nginx = {
  primary: {
    main: "#009639",
    dark: "#222222"
  },
  secondary: {
    main: "#222222"
  },
  error: {
    main: "#e40000"
  },
  custom: {
    main: "#1d9cd3"
  },
  questionnaire: {
    section: "#1d9cd3",
    textPrimary: "#222222",
    textSecondary: "#666666",
    textRequired: "#e40000",
    stripe: "#f1f3f8",
    selection: "#009639",
    checked: "#00a2df"
  },
  auth: {
    error: "#e40000",
    main: "#1d9cd3",
    title: {
      font: "'Paytone One', sans- serif"
    },
    cta: "#8700a1",
    readonly: "#1d9cd3",
    tnc: "#2b2a28"
  }
};

export const salesforce = {
  primary: {
    main: "#205c9f",
    dark: "#b0c0da"
  },
  secondary: {
    main: "#4a5568"
  },
  error: {
    main: "#e40000"
  },
  custom: {
    main: "#b0c0da"
  },
  questionnaire: {
    section: "#b0c0da",
    textPrimary: "#4a5568",
    textSecondary: "#4a5568",
    textRequired: "#e40000",
    stripe: "rgba(237, 242, 247, 1.0)",
    selection: "#205c9f",
    checked: "#205c9f"
  },
  auth: {
    error: "#e40000",
    main: "#b0c0da",
    title: {
      font: "'Paytone One', sans- serif"
    },
    cta: "#8700a1",
    readonly: "#b0c0da",
    tnc: "#2b2a28"
  }
};

export const sfds = {
  primary: {
    main: "#300b60",
    dark: "#feb9a5"
  },
  secondary: {
    main: "#4a5568"
  },
  error: {
    main: "#e40000"
  },
  custom: {
    main: "#c29ef1"
  },
  questionnaire: {
    section: "#300b60",
    textPrimary: "#333333",
    textSecondary: "#300b60",
    textRequired: "#e40000",
    stripe: "#f6f2fb",
    selection: "#333333",
    checked: "#205c9f"
  },
  auth: {
    error: "#e40000",
    main: "#c29ef1",
    title: {
      font: "'Paytone One', sans- serif"
    },
    cta: "#feb9a5",
    readonly: "#c29ef1",
    tnc: "#333333"
  }
};

export const sfdev = {
  primary: {
    main: "#260F8F",
    dark: "#1B96FF"
  },
  secondary: {
    main: "#3A49DA"
  },
  error: {
    main: "#e40000"
  },
  custom: {
    main: "#c29ef1"
  },
  questionnaire: {
    section: "#260F8F",
    textPrimary: "#444444",
    textSecondary: "#260F8F",
    textRequired: "#e40000",
    stripe: "#EAF5FF",
    selection: "#444444",
    checked: "#205c9f"
  },
  auth: {
    error: "#e40000",
    main: "#c29ef1",
    title: {
      font: "'Paytone One', sans- serif"
    },
    cta: "#032D60",
    readonly: "#c29ef1",
    tnc: "#444444"
  }
};

export const dpl = {
  primary: {
    main: "#f7a900",
    dark: "#550c70"
  },
  secondary: {
    main: "#378aff"
  },
  error: {
    main: "#e40000"
  },
  custom: {
    main: "#b0c0da"
  },
  questionnaire: {
    section: "#fd6983",
    textPrimary: "#2b2a28",
    textSecondary: "#b0c0da",
    textRequired: "#e40000",
    stripe: "#f1f3f8",
    selection: "#b0c0da",
    checked: "#378aff"
  },
  auth: {
    error: "#e40000",
    main: "#b0c0da",
    title: {
      font: "'Paytone One', sans- serif"
    },
    cta: "#6a27e8",
    readonly: "#b0c0da",
    tnc: "#2b2a28"
  }
};

// const palettes = {
//   de,
//   arvr
// };

// const palette = palettes[process.env.REACT_APP_THEME];

export default de;
